// Merged POS sync i18n — registered globally in i18n/messages.js
export const posSyncMessagesEn = {
    "posSync.action.fetch_articles": "Fetch POS articles",
    "posSync.action.full": "Full synchronization",
    "posSync.action.import_sales": "Import sales",
    "posSync.action.prepare_sales_import": "Prepare sales import",
    "posSync.action.push_catalog": "Update POS menu",
    "posSync.addSync": "Add synchronization",
    // Short variant for the page title action button (tight on mobile)
    "posSync.addSyncShort": "Add",
    "posSync.banner.cta": "Set up POS sync",
    "posSync.banner.description": "Synchronize your menu and sales between Safetee and your POS in a few steps.",
    "posSync.banner.dismiss": "Don’t show again",
    "posSync.banner.title": "Connect your cash register",
    "posSync.connection.explanation": "Verify that Safetee can reach the POS with the stored credentials.",
    "posSync.connection.failed": "Connection failed",
    "posSync.connection.success": "Connection successful",
    "posSync.connection.test": "Test connection",
    "posSync.connection.title": "Connection test",
    "posSync.correspondences.colCatalog": "Reference / Catalog",
    "posSync.correspondences.colPosArticle": "POS article",
    "posSync.correspondences.articleCode": "Code",
    "posSync.correspondences.articlePrice": "Price",
    "posSync.correspondences.colProduct": "Safetee product",
    "posSync.correspondences.colStatus": "Status",
    "posSync.correspondences.colUpdated": "Updated",
    "posSync.correspondences.emptyDescription": "Fetch articles from the cash register to start mapping.",
    "posSync.correspondences.emptyTitle": "No POS articles",
    "posSync.correspondences.fetchArticles": "Fetch POS articles",
    "posSync.correspondences.toolbarHint":
        "Each row maps a cash-register article to a Safetee product.",
    "posSync.correspondences.recomputeSuggestions": "Recalculate matching",
    "posSync.correspondences.recomputeSuggestionsDisabled":
        "No pending articles to match.",
    "posSync.correspondences.recomputeSuggestionsDone": "{count} suggestion(s) updated",
    "posSync.correspondences.filterStatus": "Status",
    "posSync.correspondences.filterScreen": "POS screen",
    "posSync.correspondences.filterMinScore": "Minimum match score",
    "posSync.correspondences.filterMissingMatching": "Missing matching",
    "posSync.correspondences.filterSuggestionKind": "Match reliability",
    "posSync.correspondences.filterSuggestionKindUnique": "Certain",
    "posSync.correspondences.filterSuggestionKindAmbiguous": "To review",
    "posSync.correspondences.autoMappedTooltip":
        "Unique match: no other product with a different name is a close candidate. Safe to link in bulk.",
    "posSync.correspondences.title": "Correspondences",
    "posSync.detail.activateTitle": "Activate this synchronization?",
    "posSync.detail.activityTab": "Activity",
    "posSync.detail.correspondencesTab": "Correspondences",
    "posSync.detail.catalogName": "Catalog",
    "posSync.detail.catalogPriority": "Priority",
    "posSync.detail.catalogsSection": "Linked catalogs",
    "posSync.detail.comingSoon": "Detailed sales will be available in a later release.",
    "posSync.detail.configTab": "Configuration",
    "posSync.detail.correspondences": "Manage correspondences",
    "posSync.detail.deactivateTitle": "Deactivate this synchronization?",
    "posSync.detail.duration": "Duration",
    "posSync.detail.emptyActivityTitle": "No sales imported yet",
    "posSync.detail.emptyActivityDescription":
        "Import sales from the cash register to see closures and the synchronization history.",
    "posSync.detail.errorsSection": "Errors (last run)",
    "posSync.detail.fetchArticles": "Fetch POS articles",
    "posSync.detail.finishedAt": "Finished",
    "posSync.detail.historySection": "Synchronization history",
    "posSync.detail.importSales": "Import sales",
    "posSync.detail.importRequiresArticlesTitle": "Fetch POS articles first",
    "posSync.detail.importRequiresArticlesText":
        "Start by fetching POS articles, then complete correspondences before importing sales.",
    "posSync.detail.importRequiresMappingTitle": "Map POS articles first",
    "posSync.detail.importRequiresMappingText":
        "{count} POS article(s) still need to be mapped or ignored before sales can be imported.",
    "posSync.detail.goToCorrespondences": "Go to correspondences",
    "posSync.detail.prepareSalesImportTitle": "Checking sales articles",
    "posSync.detail.prepareSalesImportText":
        "Reviewing articles sold in the selected period and creating missing correspondences.",
    "posSync.detail.prepareSalesImportWaiting": "Connecting to the cash register…",
    "posSync.detail.prepareSalesImportDays": "{done} / {total} days",
    "posSync.detail.prepareSalesImportLocation":
        "{name} — page {pages}, {sales} tickets ({done}/{total} locations)",
    "posSync.detail.prepareSalesImportArticles": "{done} / {total} missing articles",
    "posSync.detail.currentLocation": "Current location",
    "posSync.detail.locations": "Locations",
    "posSync.detail.page": "Page",
    "posSync.detail.tickets": "Tickets",
    "posSync.detail.days": "Days",
    "posSync.importPending.title": "Map sold POS articles",
    "posSync.importPending.subtitle":
        "{count} article(s) from this import window still need a correspondence.",
    "posSync.importPending.continue": "Continue import",
    "posSync.importPending.stillPending":
        "Some articles from this import still need to be mapped or ignored.",
    "posSync.importPending.conversionTitle":
        "These products cannot be converted to stock",
    "posSync.importPending.conversionHint":
        "Fix each product, then continue the import. The sale will not be imported while a product cannot be converted.",
    "posSync.importPending.conversionStillBlocked":
        "Some products still cannot be converted to stock.",
    "posSync.importPending.posArticles": "POS articles",
    "posSync.importPending.stockFormat": "Stock format",
    "posSync.importPending.saveFormat": "Save",
    "posSync.importPending.emptyTitle": "All articles for this import are mapped",
    "posSync.importPending.emptyDescription": "You can continue the sales import.",
    "posSync.detail.fetchArticlesBeforeImportTitle": "Checking POS articles",
    "posSync.detail.fetchArticlesBeforeImportText":
        "Looking for new cash-register items before importing sales.",
    "posSync.detail.fetchArticlesBeforeImportWaiting": "Connecting to the cash register…",
    "posSync.detail.fetchArticlesBeforeImportCount": "{done} / {total} articles",
    "posSync.detail.lastRun": "Last synchronization",
    "posSync.detail.nextScheduled": "Next scheduled",
    "posSync.detail.nextScheduledAt": "Next run: {date}",
    "posSync.detail.noCatalogs": "No catalog linked to this establishment.",
    "posSync.detail.noCatalogsDescription":
        "Link at least one sales catalog to this establishment before syncing the menu to the POS.",
    "posSync.detail.noCatalogsTitle": "No linked catalogs",
    "posSync.detail.notFound": "Synchronization not found",
    "posSync.detail.scheduleSection": "Schedule & options",
    "posSync.detail.pushCatalog": "Update POS menu",
    "posSync.detail.mappingIncompleteTitle": "Pending correspondences",
    "posSync.detail.mappingIncompleteText":
        "{count} POS article(s) are not mapped yet. You can still update the menu: unmapped POS articles and their buttons will not be modified.",
    "posSync.detail.mappingIncompleteContinue": "Update POS menu",
    "posSync.detail.viewPendingCorrespondences": "Show pending correspondences",
    "posSync.detail.salesSection": "POS sales",
    "posSync.detail.salesStub": "Sales view",
    "posSync.detail.save": "Save",
    "posSync.detail.saved": "Configuration saved",
    "posSync.detail.status": "Status",
    "posSync.detail.viewErrors": "View errors",
    "posSync.detail.lastRunErrorsHint":
        "{count} error(s) during the last run — review them before continuing.",
    "posSync.detail.lastRunWarningsHint":
        "The last run finished with warnings. Check the details if needed.",
    "posSync.detail.viewRunDetail": "View detail",
    "posSync.errorType.closure_line": "Closure line",
    "posSync.errorType.connection": "Connection",
    "posSync.errorType.product_push": "Product push",
    "posSync.errorType.stock": "Stock",
    "posSync.errors.colCode": "Support code",
    "posSync.errors.colMessage": "Message",
    "posSync.errors.colObject": "Product",
    "posSync.errors.colTime": "Time",
    "posSync.errors.colType": "Type",
    "posSync.errors.copied": "Copied to clipboard",
    "posSync.errors.copySupport": "Copy for support",
    "posSync.errors.empty": "No errors for this run.",
    "posSync.errors.filterType": "Error type",
    "posSync.history.colAction": "Action",
    "posSync.history.colCounters": "Products / closures / errors",
    "posSync.history.colFinished": "Finished",
    "posSync.history.colStarted": "Started",
    "posSync.history.colStatus": "Status",
    "posSync.history.colTrigger": "Trigger",
    "posSync.history.exportCsv": "Export CSV",
    "posSync.history.viewDetail": "View detail",
    "posSync.launch.cancel": "Cancel",
    "posSync.launch.confirm": "Start",
    "posSync.launch.importSalesTitle": "Import sales",
    "posSync.launch.importSalesHint":
        "A daily sale order is created automatically when sales are retrieved from the POS.",
    "posSync.launch.importWithoutStock": "Do not update stock",
    "posSync.launch.importWithoutStockHint":
        "Import sales into Safetee for history only, without creating warehouse stock movements.",
    "posSync.launch.warehouseMissing":
        "No warehouse is configured, so destocking is unavailable. Sales will be imported without stock movements. You can set a warehouse in Configuration.",
    "posSync.launch.importStartDate": "Import start date",
    "posSync.launch.importStartLabel": "Start date",
    "posSync.launch.importEndLabel": "End date",
    "posSync.launch.importDateTime": "Date and time",
    "posSync.launch.startModeLastSync": "Last synchronization — {date}",
    "posSync.launch.startModeCustom": "Enter date and time",
    "posSync.launch.endModeNow": "Now",
    "posSync.launch.endModeYesterdayMidnight": "Yesterday at midnight",
    "posSync.launch.endModeCustom": "Enter date and time",
    "posSync.launch.productionBlocked": "Production sync is not available for Lightspeed yet. Enable simulation mode or wait for Lot 2.",
    "posSync.launch.pushCatalogHint": "Send active menu products to the cash register. Missing POS items are created and linked automatically.",
    "posSync.launch.pushCatalogTitle": "Update POS menu",
    "posSync.launch.targetSale": "Target sale",
    "posSync.list.applyFilters": "Apply",
    "posSync.list.title": "Cash registers",
    "posSync.list.colCatalogs": "Catalogs",
    "posSync.list.colEntries": "Menu entries",
    "posSync.list.colEstablishment": "Establishment",
    "posSync.list.colLastRun": "Last sync",
    "posSync.list.colName": "Name",
    "posSync.list.colProvider": "Provider",
    "posSync.list.colStatus": "Status",
    "posSync.list.colWarehouse": "Warehouse",
    "posSync.list.emptyDescription": "Connect a cash register to synchronize your menu and sales.",
    "posSync.list.emptyTitle": "No POS synchronizations",
    "posSync.list.filterAll": "All",
    "posSync.list.filterEstablishment": "Establishment",
    "posSync.list.filterProvider": "Provider",
    "posSync.list.filterStatus": "Status",
    "posSync.list.open": "Open",
    "posSync.list.search": "Search",
    "posSync.list.statsActive": "Active syncs",
    "posSync.list.statsErrors24h": "Errors (24h)",
    "posSync.list.syncNow": "Synchronize…",
    "posSync.mapping.catalog": "Catalog",
    "posSync.mapping.catalogEntry": "Catalog entry",
    "posSync.mapping.createProductAction": "Create and link",
    "posSync.mapping.createProductTitle": "Create product and link",
    "posSync.mapping.linkModeExisting": "Link an existing product",
    "posSync.mapping.linkModeExistingDescription":
        "Choose a Safetee product already in your catalog.",
    "posSync.mapping.linkModeCreate": "Create the product",
    "posSync.mapping.linkModeCreateDescription":
        "Create a new Safetee product and link it to this article.",
    "posSync.mapping.downloadTemplate": "Download template",
    "posSync.mapping.exportCsvAction": "Export mappings (re-importable)",
    "posSync.mapping.ignored": "Ignored",
    "posSync.mapping.ignoredMissing": "Ignored and not found",
    "posSync.mapping.importColAction": "Action",
    "posSync.mapping.importColArticle": "POS article",
    "posSync.mapping.importColDetail": "Detail",
    "posSync.mapping.importColLine": "Line",
    "posSync.mapping.importColStatus": "Status",
    "posSync.mapping.importCsvAction": "Import",
    "posSync.mapping.importCsvFile": "CSV file",
    "posSync.mapping.importCsvHelp": "Import a CSV to link, create or ignore mappings between cash-register items and your Safetee products. You can also re-import a previous export as-is.",
    "posSync.mapping.importCsvCatalogHelp": "Items will be linked or created in this catalog. Catalog columns in the CSV are ignored.",
    "posSync.mapping.importCsvIgnoreErrors": "Ignore errors and import valid rows",
    "posSync.mapping.importCsvIgnoreErrorsHint": "Successful mappings are saved even if other rows fail.",
    "posSync.mapping.importCsvSummary": "{success}/{processed} rows OK ({linked} linked, {created} created, {ignored} ignored, {skipped} skipped, {errors} errors).",
    "posSync.mapping.importCsvSummaryOk": "{success}/{processed} rows OK ({linked} linked, {created} created, {ignored} ignored, {ignored_missing} ignored and not found, {skipped} skipped).",
    "posSync.mapping.importCsvSummaryErrors": "{errors} errors.",
    "posSync.mapping.importCsvNotApplied": "No changes were saved.",
    "posSync.mapping.importCsvShowErrors": "Show errors only",
    "posSync.mapping.importCsvShowAll": "Show all",
    "posSync.mapping.importCsvSelectAnother": "Select another file",
    "posSync.mapping.importStatusCreated": "Created",
    "posSync.mapping.importStatusError": "Error",
    "posSync.mapping.importCsvTitle": "Import mappings (CSV)",
    "posSync.mapping.importCsvReportTitle": "Import report",
    "posSync.mapping.linkAction": "Link",
    "posSync.mapping.linkOrCreateAction": "Link or create",
    "posSync.mapping.linkIntro":
        "Choose the Safetee catalog, product and sale format that match this cash register item. If that format already exists in the catalog, it will be reused; otherwise a new catalog entry is created.",
    "posSync.mapping.linkTitle": "Link POS article",
    "posSync.mapping.linked": "Linked",
    "posSync.mapping.format": "Sale format",
    "posSync.mapping.formatHint":
        "Catalog entry used for this POS item. Reuses an existing entry for the same format when available.",
    "posSync.mapping.unitAmount": "Sale price",
    "posSync.mapping.unitAmountHint":
        "Optional. Sale price written on the catalog entry (same VAT mode as the catalog).",
    "posSync.mapping.unitAmountHintFromPos":
        "Detected on the cash register: {price}. You can keep or edit it.",
    "posSync.mapping.pending": "Pending",
    "posSync.mapping.suggestionsTitle": "Suggested products",
    "posSync.mapping.suggestionFromFetch": "Saved suggestion",
    "posSync.mapping.suggestionsEmpty":
        "No suggestion yet. Load proposals or search for a product.",
    "posSync.mapping.suggestionsLoad": "See other proposals",
    "posSync.mapping.productSearch": "Or search for a product",
    "posSync.mapping.stockQuantity": "Total stock: {quantity}",
    "posSync.mapping.category": "Category",
    "posSync.mapping.productCode": "Product code",
    "posSync.mapping.productName": "Product name",
    "posSync.mapping.suggested": "Suggested",
    "posSync.production.blockedBanner": "Production mode is enabled but the Lightspeed connector is not active yet. Runs will fail until Lot 2 is deployed.",
    "posSync.provider.laddition": "L'Addition",
    "posSync.provider.lightspeed": "Lightspeed K-Series",
    "posSync.run.cancel": "Cancel",
    "posSync.run.cancelConfirmText": "The current run will be stopped.",
    "posSync.run.cancelConfirmTitle": "Cancel synchronization?",
    "posSync.run.closures": "Closures",
    "posSync.run.closuresShort": "Closures",
    "posSync.run.elapsed": "Elapsed",
    "posSync.run.errors": "Errors",
    "posSync.run.errorsShort": "Errors",
    "posSync.run.finishedCancelled": "Synchronization cancelled",
    "posSync.run.finishedError": "Synchronization failed",
    "posSync.run.finishedSuccess": "Synchronization completed successfully",
    "posSync.run.finishedWarnings": "Synchronization completed with warnings",
    "posSync.run.inProgress": "In progress",
    "posSync.run.recentRunConfirmConfirm": "Start anyway",
    "posSync.run.recentRunConfirmText":
        "A synchronization finished less than 5 minutes ago. Do you want to start a new one?",
    "posSync.run.recentRunConfirmTitle": "Start another synchronization?",
    "posSync.run.linesIgnored": "Lines ignored",
    "posSync.run.orderLines": "Order lines",
    "posSync.run.orderLinesShort": "Lines",
    "posSync.run.products": "Products",
    "posSync.run.productsShort": "Products",
    "posSync.run.productsCreated": "Created",
    "posSync.run.productsCreatedShort": "Created",
    "posSync.run.productsUpdated": "Updated",
    "posSync.run.productsUpdatedShort": "Updated",
    "posSync.run.productsIgnored": "Ignored",
    "posSync.run.ignoredShort": "Ignored",
    "posSync.run.productsIgnoredTooltipReasons":
        "An item can be ignored when it has no sale price, or when it is unchanged since the last successful sync.",
    "posSync.run.articlesFetched": "Articles fetched",
    "posSync.run.articlesFetchedShort": "Fetched",
    "posSync.run.mappingsCreated": "Mappings created",
    "posSync.run.windowArticles": "Sold articles",
    "posSync.run.windowArticlesShort": "Sold",
    "posSync.run.windowPending": "To map",
    "posSync.run.windowPendingShort": "To map",
    "posSync.run.mappingsUpdated": "Mappings updated",
    "posSync.run.status.cancelled": "Cancelled",
    "posSync.run.status.complete": "Complete",
    "posSync.run.status.error": "Error",
    "posSync.run.status.pending": "Pending",
    "posSync.run.status.running": "Running",
    "posSync.run.status.success": "Success",
    "posSync.run.status.success_with_warnings": "Success with warnings",
    "posSync.run.steps.fetch_articles": "Fetching POS articles",
    "posSync.run.steps.finalization": "Finalization",
    "posSync.run.steps.finalize": "Finalization",
    "posSync.run.steps.init": "Initialization",
    "posSync.run.steps.preparation": "Preparation",
    "posSync.run.steps.process_sales": "Processing sales",
    "posSync.run.steps.prepare_mappings": "Creating missing correspondences",
    "posSync.run.steps.pull_closures": "Pulling Z closures",
    "posSync.run.importLocationsStep":
        "{step} ({name} — page {pages}, {done}/{total} locations)",
    "posSync.run.steps.pull_sales": "Importing sales",
    "posSync.run.steps.push_catalog": "Sending menu to POS",
    "posSync.run.steps.stock_check": "Stock check",
    "posSync.run.steps.update_customer_sale": "Updating customer sale",
    "posSync.run.steps.update_stock": "Updating stock",
    "posSync.run.stockMoves": "Stock movements",
    "posSync.run.stockMovesShort": "Stock",
    "posSync.runDetail.title": "Run detail",
    "posSync.sales.closeConfirmTitle": "Close the current daily sale?",
    "posSync.sales.closeConfirmText":
        "The daily sale will be validated and marked as completed.",
    "posSync.sales.closeSale": "Close sale",
    "posSync.sales.closeRegister": "Close register",
    "posSync.sales.openSaleAction": "Open sale",
    "posSync.sales.openRegister": "Open last sale",
    "posSync.sales.viewAll": "View all sales",
    "posSync.sales.closeSuccess": "Daily sale closed",
    "posSync.sales.colOrderId": "Sale",
    "posSync.sales.colStatus": "Status",
    "posSync.sales.colSaleDate": "Sale date",
    "posSync.sales.colClosedAt": "Closed at",
    "posSync.sales.colClosureId": "Closure ID",
    "posSync.sales.colTotalExclVat": "Total excl. VAT",
    "posSync.sales.colTotalMarginExclVat": "Total margin (excl. VAT)",
    "posSync.sales.lastClosed": "Last closure",
    "posSync.sales.lastClosedTooltip":
        "When the previous register sale was closed for this POS sync.",
    "posSync.sales.noSales": "No sales yet",
    "posSync.sales.noSalesHint": "Sales appear after sales import runs.",
    "posSync.sales.noClosures": "No closures yet",
    "posSync.sales.noClosuresHint": "Closures appear after sales import runs.",
    "posSync.sales.noOpenSale": "None",
    "posSync.sales.openSale": "Open sale",
    "posSync.sales.openSaleTooltip":
        "Current open register sale for this POS sync. Click to open it.",
    "posSync.sales.openBadge": "Open",
    "posSync.sales.revenueOpenInclVat": "Open sale revenue (incl. VAT)",
    "posSync.sales.revenueOpenInclVatTooltip":
        "Total incl. VAT of the current open register sale (imported POS lines).",
    "posSync.sales.revenueLastInclVat": "Last sale revenue (incl. VAT)",
    "posSync.sales.revenueLastInclVatTooltip":
        "Total incl. VAT of the last register sale for this POS sync.",
    "posSync.simulation.banner": "Simulation mode — data is not sent to production POS systems.",
    "posSync.status.active": "Active",
    "posSync.status.inactive": "Inactive",
    "posSync.status.setup": "Setup required",
    "posSync.title": "POS synchronization",
    "posSync.trigger.cancel": "Cancel",
    "posSync.trigger.manual": "Manual",
    "posSync.trigger.retry": "Retry",
    "posSync.trigger.scheduled": "Scheduled",
    "posSync.wizard.autoCloseTime": "Auto-close time",
    "posSync.wizard.back": "Back",
    "posSync.wizard.cancel": "Cancel",
    "posSync.wizard.closeAfterSync": "Close sale after sync",
    "posSync.wizard.created": "Synchronization created",
    "posSync.wizard.credentialsProductionBlocked": "Production mode is active but the Lightspeed K-Series connector is not deployed yet. Sync runs will fail until Lot 2 is complete.",
    "posSync.wizard.credentialsSimulationHint": "The platform is in simulation mode: credentials are stored but runs use fake POS data.",
    "posSync.wizard.errors.nameDuplicate": "This name is already used",
    "posSync.wizard.errors.required": "Required field",
    "posSync.wizard.fieldEstablishment": "Establishment",
    "posSync.wizard.fieldName": "Synchronization name",
    "posSync.wizard.fieldNamePlaceholder": "Bar POS",
    "posSync.wizard.fieldWarehouse": "Warehouse",
    "posSync.wizard.freqDaily": "Daily",
    "posSync.wizard.freqHourly": "Hourly",
    "posSync.wizard.manageCatalogs": "Manage catalogs",
    "posSync.wizard.next": "Next",
    "posSync.wizard.oneAccountPerSync": "One synchronization = one cash register account at the provider.",
    "posSync.wizard.removeAbsentItems": "Remove catalog items absent from POS",
    "posSync.wizard.save": "Save",
    "posSync.wizard.scheduleEnabled": "Scheduled synchronization",
    "posSync.wizard.scheduleFrequency": "Frequency",
    "posSync.wizard.stepCredentials": "Credentials",
    "posSync.wizard.stepEstablishment": "Establishment",
    "posSync.wizard.stepProvider": "Provider",
    "posSync.wizard.stepSchedule": "Schedule",
    "posSync.wizard.title": "New POS synchronization"
};

export const posSyncMessagesFr = {
    "posSync.action.fetch_articles": "Récupération articles caisse",
    "posSync.action.full": "Synchronisation complète",
    "posSync.action.import_sales": "Import des ventes",
    "posSync.action.prepare_sales_import": "Préparation de l’import des ventes",
    "posSync.action.push_catalog": "Envoi carte vers la caisse",
    "posSync.addSync": "Ajouter une synchronisation",
    "posSync.addSyncShort": "Ajouter",
    "posSync.banner.cta": "Configurer la synchro caisse",
    "posSync.banner.description": "Synchronisez votre carte et vos ventes entre Safetee et votre caisse en quelques étapes.",
    "posSync.banner.dismiss": "Ne plus afficher",
    "posSync.banner.title": "Connectez votre caisse",
    "posSync.connection.explanation": "Vérifiez que Safetee peut joindre la caisse avec les identifiants enregistrés.",
    "posSync.connection.failed": "Échec de connexion",
    "posSync.connection.success": "Connexion réussie",
    "posSync.connection.test": "Tester la connexion",
    "posSync.connection.title": "Test de connexion",
    "posSync.correspondences.colCatalog": "Référence / Catalogue",
    "posSync.correspondences.colPosArticle": "Article caisse",
    "posSync.correspondences.articleCode": "Code",
    "posSync.correspondences.articlePrice": "Prix",
    "posSync.correspondences.colProduct": "Produit Safetee",
    "posSync.correspondences.colStatus": "Statut",
    "posSync.correspondences.colUpdated": "Mise à jour",
    "posSync.correspondences.emptyDescription": "Récupérez les articles depuis la caisse pour commencer le mapping.",
    "posSync.correspondences.emptyTitle": "Aucun article caisse",
    "posSync.correspondences.fetchArticles": "Récupérer les articles caisse",
    "posSync.correspondences.toolbarHint":
        "Chaque ligne associe un article caisse à un produit Safetee.",
    "posSync.correspondences.recomputeSuggestions": "Recalculer le rapprochement",
    "posSync.correspondences.recomputeSuggestionsDisabled":
        "Aucun article en attente à rapprocher.",
    "posSync.correspondences.recomputeSuggestionsDone": "{count} suggestion(s) mise(s) à jour",
    "posSync.correspondences.filterStatus": "Statut",
    "posSync.correspondences.filterScreen": "Écran caisse",
    "posSync.correspondences.filterMinScore": "Score de matching minimum",
    "posSync.correspondences.filterMissingMatching": "Matching manquant",
    "posSync.correspondences.filterSuggestionKind": "Fiabilité du matching",
    "posSync.correspondences.filterSuggestionKindUnique": "Certain",
    "posSync.correspondences.filterSuggestionKindAmbiguous": "À contrôler",
    "posSync.correspondences.autoMappedTooltip":
        "Rapprochement unique : aucun autre produit au nom différent n’est un candidat proche. Peut être lié en masse.",
    "posSync.correspondences.title": "Correspondances",
    "posSync.detail.activateTitle": "Activer cette synchronisation ?",
    "posSync.detail.activityTab": "Activité",
    "posSync.detail.correspondencesTab": "Correspondances",
    "posSync.detail.catalogName": "Catalogue",
    "posSync.detail.catalogPriority": "Priorité",
    "posSync.detail.catalogsSection": "Catalogues liés",
    "posSync.detail.comingSoon": "Le détail des ventes sera disponible dans une prochaine version.",
    "posSync.detail.configTab": "Configuration",
    "posSync.detail.correspondences": "Gérer les correspondances",
    "posSync.detail.deactivateTitle": "Désactiver cette synchronisation ?",
    "posSync.detail.duration": "Durée",
    "posSync.detail.emptyActivityTitle": "Aucun import de ventes",
    "posSync.detail.emptyActivityDescription":
        "Importez les ventes depuis la caisse pour voir les clôtures et l’historique des synchronisations.",
    "posSync.detail.errorsSection": "Erreurs (dernière exécution)",
    "posSync.detail.fetchArticles": "Récupérer les articles caisse",
    "posSync.detail.finishedAt": "Terminée",
    "posSync.detail.historySection": "Historique des synchronisations",
    "posSync.detail.importSales": "Importer les ventes",
    "posSync.detail.importRequiresArticlesTitle": "Récupérez d’abord les articles caisse",
    "posSync.detail.importRequiresArticlesText":
        "Commencez par récupérer les articles caisse, puis traitez les correspondances avant d’importer les ventes.",
    "posSync.detail.importRequiresMappingTitle": "Mappez les articles caisse",
    "posSync.detail.importRequiresMappingText":
        "{count} article(s) caisse doivent encore être mappés ou ignorés avant d’importer les ventes.",
    "posSync.detail.goToCorrespondences": "Aller aux correspondances",
    "posSync.detail.prepareSalesImportTitle": "Vérification des articles vendus",
    "posSync.detail.prepareSalesImportText":
        "Analyse des articles vendus sur la période et création des correspondances manquantes.",
    "posSync.detail.prepareSalesImportWaiting": "Connexion à la caisse…",
    "posSync.detail.prepareSalesImportDays": "{done} / {total} jours",
    "posSync.detail.prepareSalesImportLocation":
        "{name} — page {pages}, {sales} tickets ({done}/{total} lieux)",
    "posSync.detail.prepareSalesImportArticles": "{done} / {total} articles manquants",
    "posSync.detail.currentLocation": "Lieu en cours",
    "posSync.detail.locations": "Lieux",
    "posSync.detail.page": "Page",
    "posSync.detail.tickets": "Tickets",
    "posSync.detail.days": "Jours",
    "posSync.importPending.title": "Mapper les articles vendus",
    "posSync.importPending.subtitle":
        "{count} article(s) de cette plage d’import n’ont pas encore de correspondance.",
    "posSync.importPending.continue": "Continuer l’import",
    "posSync.importPending.stillPending":
        "Certains articles de cet import doivent encore être mappés ou ignorés.",
    "posSync.importPending.conversionTitle":
        "Ces produits ne peuvent pas être convertis en stock",
    "posSync.importPending.conversionHint":
        "Corrigez chaque produit, puis continuez l’import. La vente ne sera pas importée tant qu’un produit n’est pas convertible.",
    "posSync.importPending.conversionStillBlocked":
        "Certains produits ne peuvent toujours pas être convertis en stock.",
    "posSync.importPending.posArticles": "Articles caisse",
    "posSync.importPending.stockFormat": "Format de stock",
    "posSync.importPending.saveFormat": "Enregistrer",
    "posSync.importPending.emptyTitle": "Tous les articles de cet import sont mappés",
    "posSync.importPending.emptyDescription": "Vous pouvez continuer l’import des ventes.",
    "posSync.detail.fetchArticlesBeforeImportTitle": "Vérification des articles caisse",
    "posSync.detail.fetchArticlesBeforeImportText":
        "Recherche de nouveaux articles caisse avant d’importer les ventes.",
    "posSync.detail.fetchArticlesBeforeImportWaiting": "Connexion à la caisse…",
    "posSync.detail.fetchArticlesBeforeImportCount": "{done} / {total} articles",
    "posSync.detail.lastRun": "Dernière synchronisation",
    "posSync.detail.nextScheduled": "Prochaine planifiée",
    "posSync.detail.nextScheduledAt": "Prochaine exécution : {date}",
    "posSync.detail.noCatalogs": "Aucun catalogue lié à cet établissement.",
    "posSync.detail.noCatalogsDescription":
        "Liez au moins un catalogue de vente à cet établissement avant d'envoyer la carte vers la caisse.",
    "posSync.detail.noCatalogsTitle": "Aucun catalogue lié",
    "posSync.detail.notFound": "Synchronisation introuvable",
    "posSync.detail.scheduleSection": "Planification et options",
    "posSync.detail.pushCatalog": "Mettre à jour la caisse",
    "posSync.detail.mappingIncompleteTitle": "Correspondances à traiter",
    "posSync.detail.mappingIncompleteText":
        "{count} article(s) caisse ne sont pas encore mappés. Vous pouvez quand même mettre à jour la carte : les articles caisse non mappés et leurs boutons ne seront pas modifiés.",
    "posSync.detail.mappingIncompleteContinue": "Mettre à jour la caisse",
    "posSync.detail.viewPendingCorrespondences": "Afficher les correspondances à traiter",
    "posSync.detail.salesSection": "Ventes caisse",
    "posSync.detail.salesStub": "Consultation des ventes",
    "posSync.detail.save": "Enregistrer",
    "posSync.detail.saved": "Configuration enregistrée",
    "posSync.detail.status": "Statut",
    "posSync.detail.viewErrors": "Voir les erreurs",
    "posSync.detail.lastRunErrorsHint":
        "{count} erreur(s) lors de la dernière exécution — vérifiez-les avant de continuer.",
    "posSync.detail.lastRunWarningsHint":
        "La dernière exécution s’est terminée avec des réserves. Consultez le détail si besoin.",
    "posSync.detail.viewRunDetail": "Voir le détail",
    "posSync.errorType.closure_line": "Ligne de clôture",
    "posSync.errorType.connection": "Connexion",
    "posSync.errorType.product_push": "Envoi produit",
    "posSync.errorType.stock": "Stock",
    "posSync.errors.colCode": "Code support",
    "posSync.errors.colMessage": "Message",
    "posSync.errors.colObject": "Produit",
    "posSync.errors.colTime": "Heure",
    "posSync.errors.colType": "Type",
    "posSync.errors.copied": "Copié dans le presse-papiers",
    "posSync.errors.copySupport": "Copier pour le support",
    "posSync.errors.empty": "Aucune erreur pour cette exécution.",
    "posSync.errors.filterType": "Type d’erreur",
    "posSync.history.colAction": "Action",
    "posSync.history.colCounters": "Produits / clôtures / erreurs",
    "posSync.history.colFinished": "Fin",
    "posSync.history.colStarted": "Début",
    "posSync.history.colStatus": "Statut",
    "posSync.history.colTrigger": "Déclenchement",
    "posSync.history.exportCsv": "Exporter CSV",
    "posSync.history.viewDetail": "Voir le détail",
    "posSync.launch.cancel": "Annuler",
    "posSync.launch.confirm": "Lancer",
    "posSync.launch.importSalesTitle": "Importer les ventes",
    "posSync.launch.importSalesHint":
        "Une vente du jour est créée automatiquement lorsque des ventes sont récupérées depuis la caisse.",
    "posSync.launch.importWithoutStock": "Ne pas déstocker",
    "posSync.launch.importWithoutStockHint":
        "Importer les ventes dans Safetee pour l’historique uniquement, sans créer de mouvements de stock.",
    "posSync.launch.warehouseMissing":
        "Aucun entrepôt n’est configuré : le déstockage est indisponible. Les ventes seront importées sans mouvements de stock. Vous pouvez choisir un entrepôt dans Configuration.",
    "posSync.launch.importStartDate": "Date de début d’import",
    "posSync.launch.importStartLabel": "Date de début",
    "posSync.launch.importEndLabel": "Date de fin",
    "posSync.launch.importDateTime": "Date et heure",
    "posSync.launch.startModeLastSync": "Dernière synchronisation — {date}",
    "posSync.launch.startModeCustom": "Saisir la date et l’heure",
    "posSync.launch.endModeNow": "Maintenant",
    "posSync.launch.endModeYesterdayMidnight": "Hier à minuit",
    "posSync.launch.endModeCustom": "Saisir la date et l’heure",
    "posSync.launch.productionBlocked": "La synchronisation production Lightspeed n’est pas encore disponible. Activez le mode simulation ou attendez le lot 2.",
    "posSync.launch.pushCatalogHint": "Envoie les produits actifs du menu vers la caisse. Les articles absents sont créés et liés automatiquement.",
    "posSync.launch.pushCatalogTitle": "Mettre à jour la carte",
    "posSync.launch.targetSale": "Vente cible",
    "posSync.list.applyFilters": "Appliquer",
    "posSync.list.title": "Caisses",
    "posSync.list.colCatalogs": "Catalogues",
    "posSync.list.colEntries": "Entrées carte",
    "posSync.list.colEstablishment": "Établissement",
    "posSync.list.colLastRun": "Dernière synchro",
    "posSync.list.colName": "Nom",
    "posSync.list.colProvider": "Fournisseur",
    "posSync.list.colStatus": "Statut",
    "posSync.list.colWarehouse": "Entrepôt",
    "posSync.list.emptyDescription": "Connectez une caisse pour synchroniser votre carte et vos ventes.",
    "posSync.list.emptyTitle": "Aucune synchronisation caisse",
    "posSync.list.filterAll": "Toutes",
    "posSync.list.filterEstablishment": "Établissement",
    "posSync.list.filterProvider": "Fournisseur",
    "posSync.list.filterStatus": "État",
    "posSync.list.open": "Ouvrir",
    "posSync.list.search": "Rechercher",
    "posSync.list.statsActive": "Synchros actives",
    "posSync.list.statsErrors24h": "Erreurs (24 h)",
    "posSync.list.syncNow": "Synchroniser…",
    "posSync.mapping.catalog": "Catalogue",
    "posSync.mapping.catalogEntry": "Entrée catalogue",
    "posSync.mapping.createProductAction": "Créer et lier",
    "posSync.mapping.createProductTitle": "Créer le produit et lier",
    "posSync.mapping.linkModeExisting": "Lier un produit existant",
    "posSync.mapping.linkModeExistingDescription":
        "Choisissez un produit Safetee déjà présent dans votre catalogue.",
    "posSync.mapping.linkModeCreate": "Créer le produit",
    "posSync.mapping.linkModeCreateDescription":
        "Créez un nouveau produit Safetee et liez-le à cet article.",
    "posSync.mapping.downloadTemplate": "Télécharger le modèle",
    "posSync.mapping.exportCsvAction": "Exporter les correspondances (réimportable)",
    "posSync.mapping.ignored": "Ignoré",
    "posSync.mapping.ignoredMissing": "Ignoré et introuvable",
    "posSync.mapping.importColAction": "Action",
    "posSync.mapping.importColArticle": "Article caisse",
    "posSync.mapping.importColDetail": "Détail",
    "posSync.mapping.importColLine": "Ligne",
    "posSync.mapping.importColStatus": "Statut",
    "posSync.mapping.importCsvAction": "Importer",
    "posSync.mapping.importCsvFile": "Fichier CSV",
    "posSync.mapping.importCsvHelp": "Permet d’importer un CSV pour lier, créer ou ignorer des correspondances entre les articles caisse et vos produits Safetee. Vous pouvez aussi réimporter un export tel quel.",
    "posSync.mapping.importCsvCatalogHelp": "Les articles seront liés ou créés dans ce catalogue. Les colonnes catalogue du CSV sont ignorées.",
    "posSync.mapping.importCsvIgnoreErrors": "Ignorer les erreurs et importer les lignes valides",
    "posSync.mapping.importCsvIgnoreErrorsHint": "Les correspondances réussies sont enregistrées même si d’autres lignes échouent.",
    "posSync.mapping.importCsvSummary": "{success}/{processed} lignes OK ({linked} liées, {created} créées, {ignored} ignorées, {skipped} en attente, {errors} erreurs).",
    "posSync.mapping.importCsvSummaryOk": "{success}/{processed} lignes OK ({linked} liées, {created} créées, {ignored} ignorées, {ignored_missing} ignorées et introuvables, {skipped} en attente).",
    "posSync.mapping.importCsvSummaryErrors": "{errors} erreurs.",
    "posSync.mapping.importCsvNotApplied": "Aucune modification n’a été enregistrée.",
    "posSync.mapping.importCsvShowErrors": "Afficher seulement les erreurs",
    "posSync.mapping.importCsvShowAll": "Tout afficher",
    "posSync.mapping.importCsvSelectAnother": "Sélectionner un autre fichier",
    "posSync.mapping.importStatusCreated": "Créé",
    "posSync.mapping.importStatusError": "Erreur",
    "posSync.mapping.importCsvTitle": "Importer les correspondances (CSV)",
    "posSync.mapping.importCsvReportTitle": "Rapport d’import",
    "posSync.mapping.linkAction": "Lier",
    "posSync.mapping.linkOrCreateAction": "Lier ou créer",
    "posSync.mapping.linkIntro":
        "Choisissez le catalogue, le produit et le format Safetee qui correspondent à cet article caisse. Si ce format existe déjà dans le catalogue, l’entrée est réutilisée ; sinon une entrée est créée.",
    "posSync.mapping.linkTitle": "Lier l’article caisse",
    "posSync.mapping.linked": "Lié",
    "posSync.mapping.format": "Format",
    "posSync.mapping.formatHint":
        "Entrée de catalogue utilisée pour cet article caisse. Réutilise une entrée existante pour le même format si elle existe.",
    "posSync.mapping.unitAmount": "Prix de vente",
    "posSync.mapping.unitAmountHint":
        "Optionnel. Prix écrit sur l’entrée de catalogue (même régime de TVA que le catalogue).",
    "posSync.mapping.unitAmountHintFromPos":
        "Détecté sur la caisse : {price}. Vous pouvez le conserver ou le modifier.",
    "posSync.mapping.pending": "À traiter",
    "posSync.mapping.suggestionsTitle": "Produits suggérés",
    "posSync.mapping.suggestionFromFetch": "Suggestion enregistrée",
    "posSync.mapping.suggestionsEmpty":
        "Aucune suggestion pour l’instant. Chargez des propositions ou recherchez un produit.",
    "posSync.mapping.suggestionsLoad": "Voir d’autres propositions",
    "posSync.mapping.productSearch": "Ou rechercher un produit",
    "posSync.mapping.stockQuantity": "Stock total : {quantity}",
    "posSync.mapping.category": "Catégorie",
    "posSync.mapping.productCode": "Code produit",
    "posSync.mapping.productName": "Nom du produit",
    "posSync.mapping.suggested": "Suggestion",
    "posSync.production.blockedBanner": "Le mode production est actif mais le connecteur Lightspeed réel n’est pas encore disponible. Les exécutions échoueront jusqu’au déploiement du lot 2.",
    "posSync.provider.laddition": "L'Addition",
    "posSync.provider.lightspeed": "Lightspeed K-Series",
    "posSync.run.cancel": "Annuler",
    "posSync.run.cancelConfirmText": "L’exécution en cours sera interrompue.",
    "posSync.run.cancelConfirmTitle": "Annuler la synchronisation ?",
    "posSync.run.closures": "Clôtures",
    "posSync.run.closuresShort": "Clôtures",
    "posSync.run.elapsed": "Durée",
    "posSync.run.errors": "Erreurs",
    "posSync.run.errorsShort": "Erreurs",
    "posSync.run.finishedCancelled": "Synchronisation annulée",
    "posSync.run.finishedError": "Échec de la synchronisation",
    "posSync.run.finishedSuccess": "Synchronisation terminée avec succès",
    "posSync.run.finishedWarnings": "Synchronisation terminée avec réserves",
    "posSync.run.inProgress": "En cours",
    "posSync.run.recentRunConfirmConfirm": "Lancer quand même",
    "posSync.run.recentRunConfirmText":
        "Une synchronisation s'est terminée il y a moins de 5 minutes. Voulez-vous en lancer une nouvelle ?",
    "posSync.run.recentRunConfirmTitle": "Relancer une synchronisation ?",
    "posSync.run.linesIgnored": "Lignes ignorées",
    "posSync.run.orderLines": "Lignes vente",
    "posSync.run.orderLinesShort": "Lignes",
    "posSync.run.products": "Produits",
    "posSync.run.productsShort": "Produits",
    "posSync.run.productsCreated": "Créés",
    "posSync.run.productsCreatedShort": "Créés",
    "posSync.run.productsUpdated": "Mis à jour",
    "posSync.run.productsUpdatedShort": "MAJ",
    "posSync.run.productsIgnored": "Ignorés",
    "posSync.run.ignoredShort": "Ignorés",
    "posSync.run.productsIgnoredTooltipReasons":
        "Un article peut être ignoré s’il n’a pas de prix de vente, ou s’il est inchangé depuis la dernière synchronisation réussie.",
    "posSync.run.articlesFetched": "Articles récupérés",
    "posSync.run.articlesFetchedShort": "Récupérés",
    "posSync.run.mappingsCreated": "Correspondances créées",
    "posSync.run.windowArticles": "Articles vendus",
    "posSync.run.windowArticlesShort": "Vendus",
    "posSync.run.windowPending": "À mapper",
    "posSync.run.windowPendingShort": "À mapper",
    "posSync.run.mappingsUpdated": "Correspondances mises à jour",
    "posSync.run.status.cancelled": "Annulée",
    "posSync.run.status.complete": "Terminée",
    "posSync.run.status.error": "Erreur",
    "posSync.run.status.pending": "En attente",
    "posSync.run.status.running": "En cours",
    "posSync.run.status.success": "Succès",
    "posSync.run.status.success_with_warnings": "Succès avec réserves",
    "posSync.run.steps.fetch_articles": "Récupération articles caisse",
    "posSync.run.steps.finalization": "Finalisation",
    "posSync.run.steps.finalize": "Finalisation",
    "posSync.run.steps.init": "Initialisation",
    "posSync.run.steps.preparation": "Préparation",
    "posSync.run.steps.process_sales": "Traitement des ventes",
    "posSync.run.steps.prepare_mappings": "Création des correspondances manquantes",
    "posSync.run.steps.pull_closures": "Récupération clôtures Z",
    "posSync.run.importLocationsStep":
        "{step} ({name} — page {pages}, {done}/{total} lieux)",
    "posSync.run.steps.pull_sales": "Récupération des ventes",
    "posSync.run.steps.push_catalog": "Envoi de la carte vers la caisse",
    "posSync.run.steps.stock_check": "Contrôle stock",
    "posSync.run.steps.update_customer_sale": "Mise à jour de la vente client",
    "posSync.run.steps.update_stock": "Mise à jour des stocks",
    "posSync.run.stockMoves": "Mouvements stock",
    "posSync.run.stockMovesShort": "Stock",
    "posSync.runDetail.title": "Détail de l’exécution",
    "posSync.sales.closeConfirmTitle": "Clôturer la vente du jour en cours ?",
    "posSync.sales.closeConfirmText":
        "La vente du jour sera validée et marquée comme terminée.",
    "posSync.sales.closeSale": "Clôturer la vente",
    "posSync.sales.closeRegister": "Clôturer la caisse",
    "posSync.sales.openSaleAction": "Ouvrir la vente",
    "posSync.sales.openRegister": "Ouvrir la dernière vente",
    "posSync.sales.viewAll": "Voir toutes les ventes",
    "posSync.sales.closeSuccess": "Vente du jour clôturée",
    "posSync.sales.colOrderId": "Vente",
    "posSync.sales.colStatus": "Statut",
    "posSync.sales.colSaleDate": "Date de vente",
    "posSync.sales.colClosedAt": "Clôturée le",
    "posSync.sales.colClosureId": "ID clôture",
    "posSync.sales.colTotalExclVat": "Total HT",
    "posSync.sales.colTotalMarginExclVat": "Marge totale HT",
    "posSync.sales.lastClosed": "Dernière clôture",
    "posSync.sales.lastClosedTooltip":
        "Date de clôture de la précédente vente de caisse pour cette synchro.",
    "posSync.sales.noSales": "Aucune vente",
    "posSync.sales.noSalesHint":
        "Les ventes apparaissent après des imports depuis la caisse.",
    "posSync.sales.noClosures": "Aucune clôture",
    "posSync.sales.noClosuresHint": "Les clôtures apparaissent après des imports de ventes.",
    "posSync.sales.noOpenSale": "Aucune",
    "posSync.sales.openSale": "Vente ouverte",
    "posSync.sales.openSaleTooltip":
        "Vente de caisse ouverte pour cette synchro. Cliquez pour l’ouvrir.",
    "posSync.sales.openBadge": "Ouverte",
    "posSync.sales.revenueOpenInclVat": "CA vente ouverte (TTC)",
    "posSync.sales.revenueOpenInclVatTooltip":
        "Total TTC de la vente de caisse ouverte (lignes importées depuis la caisse).",
    "posSync.sales.revenueLastInclVat": "CA dernière vente (TTC)",
    "posSync.sales.revenueLastInclVatTooltip":
        "Total TTC de la dernière vente de caisse pour cette synchro.",
    "posSync.simulation.banner": "Mode simulation — les données ne sont pas envoyées en production sur la caisse.",
    "posSync.status.active": "Activée",
    "posSync.status.inactive": "Désactivée",
    "posSync.status.setup": "À configurer",
    "posSync.title": "Synchronisation caisse",
    "posSync.trigger.cancel": "Annulation",
    "posSync.trigger.manual": "Manuel",
    "posSync.trigger.retry": "Nouvelle tentative",
    "posSync.trigger.scheduled": "Planifié",
    "posSync.wizard.autoCloseTime": "Heure de clôture auto",
    "posSync.wizard.back": "Précédent",
    "posSync.wizard.cancel": "Annuler",
    "posSync.wizard.closeAfterSync": "Clôturer la vente après synchro",
    "posSync.wizard.created": "Synchronisation créée",
    "posSync.wizard.credentialsProductionBlocked": "Le mode production est actif mais le connecteur Lightspeed K-Series n’est pas encore déployé. Les synchronisations échoueront jusqu’à la fin du lot 2.",
    "posSync.wizard.credentialsSimulationHint": "La plateforme est en mode simulation : les identifiants sont enregistrés mais les exécutions utilisent des données caisse fictives.",
    "posSync.wizard.errors.nameDuplicate": "Ce nom est déjà utilisé",
    "posSync.wizard.errors.required": "Champ obligatoire",
    "posSync.wizard.fieldEstablishment": "Établissement",
    "posSync.wizard.fieldName": "Nom de la synchronisation",
    "posSync.wizard.fieldNamePlaceholder": "Caisse Bar",
    "posSync.wizard.fieldWarehouse": "Entrepôt",
    "posSync.wizard.freqDaily": "Quotidienne",
    "posSync.wizard.freqHourly": "Horaire",
    "posSync.wizard.manageCatalogs": "Gérer les catalogues",
    "posSync.wizard.next": "Suivant",
    "posSync.wizard.oneAccountPerSync": "Une synchronisation = un compte caisse chez l’éditeur.",
    "posSync.wizard.removeAbsentItems": "Retirer les articles absents de la caisse",
    "posSync.wizard.save": "Enregistrer",
    "posSync.wizard.scheduleEnabled": "Synchronisation planifiée",
    "posSync.wizard.scheduleFrequency": "Fréquence",
    "posSync.wizard.stepCredentials": "Identifiants",
    "posSync.wizard.stepEstablishment": "Établissement",
    "posSync.wizard.stepProvider": "Fournisseur",
    "posSync.wizard.stepSchedule": "Planification",
    "posSync.wizard.title": "Nouvelle synchronisation caisse"
};
